export enum ModalType {
  DeleteAccount = 'deleteAccount',
  SelectAccount = 'selectAccount',
  SuccessTransfer = 'successTransfer',
  ScheduledSuccessTransfer = 'scheduledSuccessTransfer',
  DepositPreview = 'depositPreview',
  WithdrawPreview = 'withdrawPreview',
}
